"use client"
import React from "react";
import Image from "next/image";
import trueCircle from "@/public/images/trueCircle.svg";
import { useTranslate } from "@/components/base/providers/TranslateProv";

interface AboutUniversityProps {
  item: any;
}

const AboutUniversity: React.FC<AboutUniversityProps> = ({ item }) => {
  const { locale } = useTranslate() as { locale: "ar" | "en" };

  return (
    <>
      <p className="text-25 text-[#141522] font-[600] text-center mb-10">
        {locale === "ar" ? `وصف عن ${item.name.ar}` : `About ${item.name.en}`}
      </p>
      <div className="flex flex-col gap-10 mb-10">
        <p
          className="text-18 text-darkText"
          dangerouslySetInnerHTML={{ __html: item.description[locale] }}
        ></p>
      </div>
      <p className="text-25 text-[#141522] font-[600] mb-5">
        {locale === "ar"
          ? `مميزات ${item.name.ar}`
          : `Features of ${item.name.en}`}
      </p>
      {item.advantages[locale].map((feature: any, index: number) => (
        <div
          className="flex items-center gap-3 mb-4"
          key={index}
        >
          <Image
            src={trueCircle}
            alt="feature-icon"
          />
          <p className="text-18 text-darkText">{feature}</p>
        </div>
      ))}
    </>
  );
};

export default AboutUniversity;
